import { PureComputed } from 'knockout';
import { injectable, inject } from 'inversify';
import { SelectDropdown } from 'components/dropdowns/select/select';
import { Tool, JSONTool, ToolVM } from '../tool';
import { wccModules } from 'enums/wccModules';

import './select.html';

components.preload('wcc-select');

interface JSONSelectTool extends JSONTool {
    select: SelectDropdown
}

export class SelectTool extends Tool {
    component = 'chat-editor-select-tool'

    select: SelectDropdown        

    constructor(jsonModel: JSONSelectTool) {
        super(jsonModel);

        this.select = jsonModel.select;
    }
}

@injectable()
export default class SelectToolVM extends ToolVM {
    icon: PureComputed<string | undefined>

    select: SelectDropdown

    constructor(
        @inject(wccModules.componentConfig) model: SelectTool,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(model, info.element);

        this.select = model.select;
        this.icon = model.icon;
    }
}